import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Login.css'; // Reuse login styles

const LoginSuccess = () => {
    const { loginWithToken } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const redirect = params.get('redirect') || '/dashboard';

        if (token) {
            const finishLogin = async () => {
                try {
                    await loginWithToken(token);
                    navigate(redirect);
                } catch (error) {
                    console.error('Login success processing failed:', error);
                    navigate('/login?error=processing_failed');
                }
            };
            finishLogin();
        } else {
            navigate('/login');
        }
    }, [location, loginWithToken, navigate]);

    return (
        <div className="login-container">
            <div className="login-card">
                <h2 className="premium-text gradient-text">Authenticating...</h2>
                <div className="loading-spinner"></div>
                <p>Please wait while we complete your login.</p>
            </div>
        </div>
    );
};

export default LoginSuccess;
